<template>
  <div id="insulin-resistance">
    <div class="tw-grid tw-grid-cols-1 tw-gap-y-1">
      <b-form-group :label="$t('tools.insulin.triglycerides')" label-for="edit-triglycerides">
        <b-input-group :append="$t('tools.append.mg_dl')">
          <b-form-input id="edit-triglycerides" v-model="triglycerides" type="text"
                        :placeholder="$t('tools.insulin.triglycerides')"
                        v-decimal></b-form-input>
        </b-input-group>
      </b-form-group>

      <b-form-group :label="$t('tools.insulin.glucose')" label-for="edit-glucose">
        <b-input-group :append="$t('tools.append.mg_dl')">
          <b-form-input id="edit-glucose" v-model="glucose" type="text"
                        :placeholder="$t('tools.insulin.glucose')"
                        v-decimal></b-form-input>
        </b-input-group>
      </b-form-group>

      <div class="tw-text-right">
        <b-button variant="primary" @click="calculate">{{ $t('tools.insulin.btn') }}</b-button>
      </div>

      <div v-if="result" class="tw-mt-2">
        <div class="tool-result">
          <div>{{ $t('tools.insulin.result.prefix') }}: <strong>{{ round(tyg) }}</strong></div>
          <div v-html="$t('tools.insulin.result.title', {result})" />
          <div v-if="parseFloat(tyg) >= 8.5">{{ $t('tools.insulin.result.nafld') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      triglycerides: null,
      glucose: null,
      result: null,
      tyg: null
    }
  },
  methods:{
    calculate(){
      this.tyg = parseFloat(this.triglycerides) * parseFloat(this.glucose) / (2 * 1000);
      if(this.tyg >= 4.49){
        this.result = this.$t('tools.insulin.low');
      }else{
        this.result = this.$t('tools.insulin.high')
      }
    }
  }
}

</script>
